import styles from './TeamListFooter.module.css'
import { Button } from '@/components/Button'
import { isRefreshDesign } from '@/infra/design'

export interface TeamListFooterProps {
  onCreate: () => void
}

export function TeamListFooter({ onCreate }: TeamListFooterProps) {
  return (
    <div className={styles.root}>
      <div className={styles.text}>
        Need a new team?{' '}
        <Button
          label="Create Team"
          variant="text"
          size={isRefreshDesign ? 'baseline' : 'normal'}
          onPress={onCreate}
        />
      </div>
    </div>
  )
}
